/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createStagingFareFromDiscriminatorValue, type ProblemDetails, type StagingFare } from '../models/index.js';
// @ts-ignore
import { CreateCsvRequestBuilderRequestsMetadata, type CreateCsvRequestBuilder } from './createCsv/index.js';
// @ts-ignore
import { CreateFromCsvRequestBuilderRequestsMetadata, type CreateFromCsvRequestBuilder } from './createFromCsv/index.js';
// @ts-ignore
import { InsertSelectedFareRequestBuilderRequestsMetadata, type InsertSelectedFareRequestBuilder } from './insertSelectedFare/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /StagingFare
 */
export interface StagingFareRequestBuilder extends BaseRequestBuilder<StagingFareRequestBuilder> {
    /**
     * The CreateCsv property
     */
    get createCsv(): CreateCsvRequestBuilder;
    /**
     * The CreateFromCsv property
     */
    get createFromCsv(): CreateFromCsvRequestBuilder;
    /**
     * The InsertSelectedFare property
     */
    get insertSelectedFare(): InsertSelectedFareRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<StagingFare[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<StagingFare[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const StagingFareRequestBuilderUriTemplate = "{+baseurl}/StagingFare";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const StagingFareRequestBuilderNavigationMetadata: Record<Exclude<keyof StagingFareRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    createCsv: {
        requestsMetadata: CreateCsvRequestBuilderRequestsMetadata,
    },
    createFromCsv: {
        requestsMetadata: CreateFromCsvRequestBuilderRequestsMetadata,
    },
    insertSelectedFare: {
        requestsMetadata: InsertSelectedFareRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const StagingFareRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: StagingFareRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createStagingFareFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
